var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"checklists"}},[_vm._l((_vm.checklists),function(checklist){return [_c('ChecklistItem',{attrs:{"checklist":checklist}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }